module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "becprice-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v("B.E.C. nº " + _vm._s(_vm.becprice.number) + ", " + _vm._s(_vm.becprice.year) + " T" + _vm._s(_vm.becprice.quarter)), (_vm.becprice.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('h2', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(_vm.becproperty.name_ca))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(_vm.becproperty.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.becproperty.name_es))])]), _vm._v(" "), (_vm.becprice.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.becprice.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.becprice.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Data')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.number),
        expression: "becprice.number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.number = $event.target.value
        }, _vm.set_becprice_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.year),
        expression: "becprice.year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.year = $event.target.value
        }, _vm.set_becprice_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quarter')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.quarter),
        expression: "becprice.quarter"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.quarter)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.quarter = $event.target.value
        }, _vm.set_becprice_quarter],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Prices')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {}, [_c('table', {
      staticClass: "table-striped",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "120px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Price')) + " (€/m²)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Movimiento tierras")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.movimiento_tierras),
        expression: "becprice.movimiento_tierras"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.movimiento_tierras)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.movimiento_tierras = $event.target.value
        }, _vm.set_becprice_movimiento_tierras],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Cimentación y muro sótano")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.cimentacion_y_muro_sotano),
        expression: "becprice.cimentacion_y_muro_sotano"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.cimentacion_y_muro_sotano)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.cimentacion_y_muro_sotano = $event.target.value
        }, _vm.set_becprice_cimentacion_y_muro_sotano],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Estructura")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.estructura),
        expression: "becprice.estructura"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.estructura)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.estructura = $event.target.value
        }, _vm.set_becprice_estructura],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Saneamiento (horizontal y vertical)")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.saneamiento),
        expression: "becprice.saneamiento"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.saneamiento)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.saneamiento = $event.target.value
        }, _vm.set_becprice_saneamiento],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería gruesa")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_gruesa),
        expression: "becprice.albanileria_gruesa"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_gruesa)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_gruesa = $event.target.value
        }, _vm.set_becprice_albanileria_gruesa],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería, azoteas e impermeabilización")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_azoteas),
        expression: "becprice.albanileria_azoteas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_azoteas)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_azoteas = $event.target.value
        }, _vm.set_becprice_albanileria_azoteas],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería, acabados de fachada")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_acabados_fachada),
        expression: "becprice.albanileria_acabados_fachada"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_acabados_fachada)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_acabados_fachada = $event.target.value
        }, _vm.set_becprice_albanileria_acabados_fachada],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería, solados")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_solados),
        expression: "becprice.albanileria_solados"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_solados)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_solados = $event.target.value
        }, _vm.set_becprice_albanileria_solados],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería, acabados interiores")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_acabados_interiores),
        expression: "becprice.albanileria_acabados_interiores"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_acabados_interiores)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_acabados_interiores = $event.target.value
        }, _vm.set_becprice_albanileria_acabados_interiores],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería, ayudas a industriales")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_ayudas_industriales),
        expression: "becprice.albanileria_ayudas_industriales"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_ayudas_industriales)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_ayudas_industriales = $event.target.value
        }, _vm.set_becprice_albanileria_ayudas_industriales],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Yesería cielosrasos")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.yeseria_cielosrasos),
        expression: "becprice.yeseria_cielosrasos"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.yeseria_cielosrasos)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.yeseria_cielosrasos = $event.target.value
        }, _vm.set_becprice_yeseria_cielosrasos],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Cerrajería")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.cerrajeria),
        expression: "becprice.cerrajeria"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.cerrajeria)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.cerrajeria = $event.target.value
        }, _vm.set_becprice_cerrajeria],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Carpintería exterior")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.carpinteria_exterior),
        expression: "becprice.carpinteria_exterior"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.carpinteria_exterior)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.carpinteria_exterior = $event.target.value
        }, _vm.set_becprice_carpinteria_exterior],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Carpintería interior")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.carpinteria_interior),
        expression: "becprice.carpinteria_interior"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.carpinteria_interior)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.carpinteria_interior = $event.target.value
        }, _vm.set_becprice_carpinteria_interior],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Persianas")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.persianas),
        expression: "becprice.persianas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.persianas)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.persianas = $event.target.value
        }, _vm.set_becprice_persianas],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Fontanería")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.fontaneria),
        expression: "becprice.fontaneria"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.fontaneria)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.fontaneria = $event.target.value
        }, _vm.set_becprice_fontaneria],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Material sanitario grifería")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.mat_sanitario_griferia),
        expression: "becprice.mat_sanitario_griferia"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.mat_sanitario_griferia)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.mat_sanitario_griferia = $event.target.value
        }, _vm.set_becprice_mat_sanitario_griferia],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Electricidad")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.electricidad),
        expression: "becprice.electricidad"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.electricidad)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.electricidad = $event.target.value
        }, _vm.set_becprice_electricidad],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Aire acondicionado")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.aire_acondicionado),
        expression: "becprice.aire_acondicionado"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.aire_acondicionado)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.aire_acondicionado = $event.target.value
        }, _vm.set_becprice_aire_acondicionado],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Instalaciones especiales")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.instal_especiales),
        expression: "becprice.instal_especiales"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.instal_especiales)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.instal_especiales = $event.target.value
        }, _vm.set_becprice_instal_especiales],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Fumistería y muebles cocina")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.fumisteria_y_muebles_cocina),
        expression: "becprice.fumisteria_y_muebles_cocina"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.fumisteria_y_muebles_cocina)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.fumisteria_y_muebles_cocina = $event.target.value
        }, _vm.set_becprice_fumisteria_y_muebles_cocina],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Ascensores")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.ascensores),
        expression: "becprice.ascensores"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.ascensores)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.ascensores = $event.target.value
        }, _vm.set_becprice_ascensores],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Vidrieria")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.vidrieria),
        expression: "becprice.vidrieria"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.vidrieria)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.vidrieria = $event.target.value
        }, _vm.set_becprice_vidrieria],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Pintura y estucos")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.pintura_y_estucos),
        expression: "becprice.pintura_y_estucos"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.pintura_y_estucos)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.pintura_y_estucos = $event.target.value
        }, _vm.set_becprice_pintura_y_estucos],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Calefacción")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.calefaccion),
        expression: "becprice.calefaccion"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.calefaccion)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.calefaccion = $event.target.value
        }, _vm.set_becprice_calefaccion],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Energía solar a.c.s.")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.energia_solar_acs),
        expression: "becprice.energia_solar_acs"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.energia_solar_acs)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.energia_solar_acs = $event.target.value
        }, _vm.set_becprice_energia_solar_acs],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Jardinería decorativa")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.jardineria_decorativa),
        expression: "becprice.jardineria_decorativa"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.jardineria_decorativa)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.jardineria_decorativa = $event.target.value
        }, _vm.set_becprice_jardineria_decorativa],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Renovación de aire")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.renovacion_aire),
        expression: "becprice.renovacion_aire"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.renovacion_aire)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.renovacion_aire = $event.target.value
        }, _vm.set_becprice_renovacion_aire],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Subtotal")])]), _vm._v(" "), _c('td', [_c('strong', [_c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.becprice.subtotal)) + " €/m²")])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Seguridad y salud (2%)")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.becprice.seguridad_y_salud)) + " €/m²")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', [_c('strong', [_c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.becprice.total)) + " €/m²")])])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentBecProperty({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentBecProperty({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.becprice.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39ec8e04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/becprices/BecPriceEditor.vue
// module id = 2131
// module chunks = 0